import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from '../hooks/useTranslation';

interface Props {
  description?: string;
  lang?: string;
  meta?: [];
  title: string;
  image?: string;
}

function Seo({ description, lang = 'en', meta = [], title, image }: Props) {
  const {
    site,
  }: {
    site: {
      siteMetadata: {
        title: string;
        image: string;
        siteUrl: string;
      };
    };
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            image
            siteUrl
          }
        }
      }
    `,
  );
  const t = useTranslation();

  const metaDescription = description || t('meta_description');
  const metaImage = image
    ? `${site.siteMetadata.siteUrl}${image}`
    : `${site.siteMetadata.siteUrl}${site.siteMetadata.image}`;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

export default Seo;
